import { useSnackbar } from 'notistack';

/**
 * Displays a "Toast" message using the notistack snackbar.
 */
const useToastMessage = () => {
  const { enqueueSnackbar } = useSnackbar();

  /**
   * Displays a message using the notistack snackbar.
   *
   * @param {string} message - The message to display in the alert.
   * @param {string} type - The type of message to display in the alert. (Valid values: default, error, info, success, or warning)
   * @param {function} [handleClose] - Optional callback function to execute when the message is closed.
   * The function receives two arguments: the Email and the reason for closing.
   */
  const showMessage = (message, type, handleClose) => {
    enqueueSnackbar(message, {
      variant: type,
      autoHideDuration: 3000,
      preventDuplicate: true,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      onClose: (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        if (handleClose) {
          handleClose(event, reason);
        }
      },
    });
  };

  return showMessage;
};

export default useToastMessage;
